/**
 * The one way out of a session.
 *
 * It lived inside `MenuBar` while the menu bar was the only chrome that could
 * offer it. NFR-05 puts a phone in front of the same application, where the menu
 * bar is not rendered at all — so the command moved here rather than being typed
 * a second time into the mobile navigation. Two logouts that clear different
 * things is the kind of bug nobody finds until a shared reception machine hands
 * the next user the previous one's patients.
 */

import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { queryClient } from '@/lib/query-client';
import { useAuthStore } from '@/stores/auth.store';

/** Route the guard sends an anonymous visitor to; kept in step with `MenuBar`'s table. */
const LOGIN_ROUTE = '/login';

export function useLogout(): () => void {
  const navigate = useNavigate();

  return useCallback(() => {
    // Reception machines are shared. Dropping the cache with the session stops
    // the next user seeing the previous one's patients in a stale query.
    queryClient.clear();
    useAuthStore.getState().clear();
    navigate(LOGIN_ROUTE, { replace: true });
  }, [navigate]);
}
